import { PrimaryButton } from '../PrimaryButton'
import { SecondaryButton } from '../SecondaryButton'
import Image from 'next/image'
import PlayStore from '../../../public/assets/playstore.png'
import RoleHero from '../../../public/assets/hero.webp'
import { Button } from 'antd'
import { useRouter } from 'next/router'


function JobRoles() {
  const router = useRouter()
  return (
    <div className="p-[24px]" id="hero-2">
      <div id="btn" className="mt-[28px] flex w-[100%] space-x-[16px]">
        <div className="w-[50%]">
        <Button className="border-secondary bg-secondary font-noto-sans  text-greyTitleBase900 font-[600] text-[14px] h-[48px]" style={{width:"100%",paddingLeft:"16px",paddingRight:"16px"}}><a href='https://play.google.com/store/apps/details?id=get.lokal.localjobs&hl=en_IN' className='text-greyTitleBase900'>Download App</a></Button>

       
        </div>
        <div className="w-[50%]">
          <SecondaryButton title={'Search jobs'} className='h-[48px] border-[#989898]' onClick={()=>{
              router.push('/jobs/jobs-near-me')
          }} titleClass='text-[16px]'/>
        </div>
      </div>
      <div id="playstore" className="font-noto-sansNormal mt-[8px] text-[14px] text-[#666]">
        <Image src={PlayStore} width={16} height={16} alt='playstore' /> 10,00,000,+ downloads
      </div>
      <div id="" className='mt-[77px] flex justify-center'>
        <Image src={RoleHero} width={312} height={333} alt='hero_image' />

      </div>
    </div>
  )
}

export default JobRoles
